import { render, staticRenderFns } from "./BuilderStep.vue?vue&type=template&id=f524d882&scoped=true"
import script from "./BuilderStep.vue?vue&type=script&lang=js"
export * from "./BuilderStep.vue?vue&type=script&lang=js"
import style0 from "./BuilderStep.vue?vue&type=style&index=0&id=f524d882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f524d882",
  null
  
)

export default component.exports